import React from 'react';
import { PropTypes } from 'prop-types';
import { useField } from 'formik';
import { BodyMedium, LinkLarge } from '@styled';

const Radio = ({ label, linkLabel, value, ...props }) => {
    const [field] = useField(props);
    const { name, onChange } = props;
    const id = `radio-${name}-${value}`;

    const renderLabel = () => {
        if (linkLabel?.text && linkLabel?.url) {
            return <LinkLarge href={linkLabel.url}>{linkLabel.text}</LinkLarge>;
        }
        return label;
    };

    return (
        <label className="block" htmlFor={id}>
            <input
                id={id}
                className="form-radio-input mr-0.5rem"
                name={name}
                type="radio"
                value={value}
                checked={field.value === value}
                onChange={e => {
                    field.onChange(e);
                    if (onChange) {
                        onChange(e);
                    }
                }}
                onBlur={field.onBlur}
            />
            <BodyMedium as="span">{renderLabel()}</BodyMedium>
        </label>
    );
};

Radio.propTypes = {
    label: PropTypes.string,
    linkLabel: PropTypes.shape({
        text: PropTypes.string,
        url: PropTypes.string,
    }),
    name: PropTypes.string,
    onChange: PropTypes.func,
    value: PropTypes.string,
};

export default Radio;
